import MailMessageService from '@/services/MailMessageService'

const createMailMessageModule = () => ({
  namespaced: true,
  state: {
    page: 1,
    pages: 1,
    pageSize: 15,
    total: 0,
    mailMessages: []
  },
  actions: {
    getMailMessages: ({ commit, state }) => {
      MailMessageService.getMailMessages(state.pageSize, state.page)
        .then((data) => {
          commit('SET_MAIL_MESSAGES', { mailMessages: data.mailMessages })
          commit('SET_PAGES', { pages: data.pages })
          commit('SET_TOTAL', { total: data.total })
        })
        .catch((err) => {
          console.info(err)
        })
    },
    setPage: ({ dispatch, commit, state }, page) => {
      commit('SET_PAGE', { page })
      dispatch('getMailMessages')
    }
  },
  getters: {
    prevDisabled: (state) => state.page === 1,
    nextDisabled(state) {
      return state.pageSize * state.page >= state.total
    }
  },
  mutations: {
    SET_MAIL_MESSAGES: (state, { mailMessages }) => {
      state.mailMessages = mailMessages
    },
    SET_PAGES: (state, { pages }) => {
      state.pages = pages
    },
    SET_PAGE: (state, { page }) => {
      state.page = page
    },
    SET_TOTAL: (state, { total }) => {
      state.total = total
    }
  }
})

export default createMailMessageModule
